export var returnFirstArgument = function returnFirstArgument(value) {
  return value;
};